<template>
  <div>
    <WdsButton
      primary
      data-test="invite-recruiter-button"
      @click="() => toggleShowCreateCompanyRecruiterModal(true)"
    >
      {{ $t('Invite recruitment agency') }}
    </WdsButton>

    <Teleport to="#modals">
      <CompanyRecruiterModal
        :show="showCompanyRecruiterModal"
        :on-cancel="() => toggleShowCreateCompanyRecruiterModal(false)"
        :on-confirm="onConfirm"
        :title="$t('Invite recruitment agency')"
        :save-button-text="$t('Invite')"
        :save-button-text-while-working="$t('Inviting')"
        :company-recruiter-ids="companyRecruiterIds"
        :manage-workers="manageWorkers"
        :can-configure-recruiter-manages-workers="canConfigureRecruiterManagesWorkers"
      />
    </Teleport>
  </div>
</template>

<script>
import { WdsButton } from '@worksome/wds-components'
import CompanyRecruiterModal from '@/components/Contacts/CompanyRecruiter/CompanyRecruiterModal.vue'
import { CreateCompanyRecruiterMutation } from '@/components/Contacts/CompanyRecruiter/mutations/CreateCompanyRecruiterMutation'
import { InviteCompanyRecruiterMutation } from '@/components/Contacts/CompanyRecruiter/mutations/InviteCompanyRecruiterMutation'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'

export default {
  name: 'AddCompanyRecruiter',
  components: { CompanyRecruiterModal, WdsButton },
  props: {
    // Ids of existing company recruiters
    companyRecruiterIds: {
      type: Array,
      default: [],
    },
    manageWorkers: {
      type: Boolean,
      default: false,
    },
    canConfigureRecruiterManagesWorkers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCompanyRecruiterModal: false,
    }
  },
  methods: {
    toggleShowCreateCompanyRecruiterModal(value) {
      this.searchValue = ''
      this.searchError = undefined
      this.showCompanyRecruiterModal = value
    },
    onConfirm(data) {
      let mutation
      if (data.createMode) {
        mutation = {
          mutation: CreateCompanyRecruiterMutation,
          variables: {
            input: {
              company: currentAccount.globalId,
              name: data.name,
              email: data.email,
              recruiterFee: data.recruiterFee,
              recruiterOwnershipDays: data.recruiterOwnershipDays,
              maxCandidateSubmissions: data.maxCandidateSubmissions,
              message: data.message,
              tags: data.tags,
              ...(data.managesWorkers !== undefined && { managesWorkers: data.managesWorkers }),
            },
          },
        }
      } else {
        mutation = {
          mutation: InviteCompanyRecruiterMutation,
          variables: {
            input: {
              id: data.id,
              company: currentAccount.globalId,
              recruiterFee: data.recruiterFee,
              recruiterOwnershipDays: data.recruiterOwnershipDays,
              maxCandidateSubmissions: data.maxCandidateSubmissions,
              message: data.message,
              tags: data.tags,
              ...(data.managesWorkers !== undefined && { managesWorkers: data.managesWorkers }),
            },
          },
        }
      }

      return publicApi
        .mutate(mutation)
        .then((result) => {
          this.$emit('added')
          return result
        })
        .catch((error) => {
          throw error
        })
    },
  },
}
</script>
